import { render } from "./TabsQuestions.vue?vue&type=template&id=cc3bf74a&scoped=true"
import script from "./TabsQuestions.vue?vue&type=script&lang=js"
export * from "./TabsQuestions.vue?vue&type=script&lang=js"

import "./TabsQuestions.vue?vue&type=style&index=0&id=cc3bf74a&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3bf74a"]])

export default __exports__